<template>
  <!-- 分页组件内容 -->
    <div class="block-pagination">
      <el-pagination
          :class="className"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          :pager-count="pagerCount"
          layout="total, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </div>
</template>

<script>
export default {
  name: 'paginationComponent',
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    className: {
      type: String,
      default: 'default',
    },
    pagerCount: {
      type: Number,
      default: 5,
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('currentChange', val);
    },
    handleCurrentChange(val) {
      this.$emit('currentChange', val);
    },
  },
};
</script>

<style scoped lang="stylus">
// 按钮的默认样式方便后期自定义扩展调试
.default {
  &. /deep/ .el-pagination {
    .el-pager {
      .number, .btn-quicknext {
        width: 40px;
        height: 40px;
        border-radius: 4px;
        border: 1px solid #DADADA;
        background-color transparent
        padding 6px 13px
        box-sizing border-box
      }
    }
    .btn-prev {
      background-color transparent
    }
    .btn-next {
      background-color transparent
    }
  }
}
</style>
